import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/public/active-day-research-img.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/active-day-value/DynChartPage.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/[locale]/active-day-value/styles.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/shared/components/InstallSection/index.tsx");
